import React, { useState, useContext, useEffect, createRef, useRef, useMemo } from "react";
import i18next from "i18next";
import { DebounceInput } from "react-debounce-input";
import { useTranslation } from "react-i18next";
import { formatMs, TextField } from "@mui/material";
import "../../styles/components/ToolBarLeftPanel.scss";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import withStyles from '@mui/styles/withStyles';
import PropTypes from "prop-types";
import microsoft from "../../images/teamwork.jfif";
import Grid from "../../images/Grid.svg";
import Single from "../../images/Single.svg";
import SingleBlue from "../../images/SingleBlue.svg";
import gridBlue from "../../images/gridBlue.svg";
import ClearText from "../../images/ClearText.svg";
import ImgSvg from "../../images/DragZoneImage.svg";
import warning from "../../images/warning.svg"
import Dropzone from "react-dropzone";
import { IMAGE } from "../../Uitls/ComponentType";

const sortByCreatedDateTime = (images) => {
  const getSortTime = (image) => {
    if (image.createdDateTime) {
      return new Date(image.createdDateTime).getTime();
    }
    return Number.MAX_SAFE_INTEGER;
  };

  return [...images].sort((a, b) => {
    const dateDiff = getSortTime(b) - getSortTime(a);
    if (dateDiff !== 0) {
      return dateDiff;
    }
    return (b.id || b.s3Url || "").localeCompare(a.id || a.s3Url || "");
  });
};

const LibraryImageItem = ({ linkImage, getLayerDetails, showDragEnd = false }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    setIsLoaded(false);
    const img = imgRef.current;
    if (img?.complete && img.naturalWidth > 0) {
      setIsLoaded(true);
    }
  }, [linkImage.s3Url]);

  return (
    <div className="imagePattern">
      <img
        ref={imgRef}
        key={linkImage.s3Url}
        src={linkImage.s3Url}
        className={`brandTabImages img-fluid${isLoaded ? " is-loaded" : ""}`}
        alt=""
        draggable={true}
        onLoad={() => setIsLoaded(true)}
        onDragStart={(e) => {
          e.dataTransfer.setData("url", linkImage.s3Url);
          getLayerDetails(e.target.id, IMAGE, linkImage.s3Url);
        }}
        onDragEnd={
          showDragEnd
            ? () => {
                getLayerDetails("", "");
              }
            : undefined
        }
        onDrag={(e) => {
          e.dataTransfer.setData("url", linkImage.s3Url);
        }}
      />
    </div>
  );
};

const AntTabs = withStyles({
  root: {
    // width:'328px',
    color: "#000000",
    //width: "67px",
  },
  indicator: {
    backgroundColor: "#203662",
    bottom: "10px",

    // display:"none"
  },
})(Tabs);
const AntTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 68,
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      key={index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
const ImageLibrary = ({
  linkImages,
  getLayerDetails,
  showToast,
  showToastForUplaod,
  handleClearToast,
  handleClearLinkToast,
  tab1Value,
  handleTab1,
  showErrToast,
  handleClearLinkErrToast,
  showErrToastUpload,
  onDropImage,
  handleURL,
  URLUpdate,
  URLValue
}) => {
  const dropzoneRef = createRef();

  const { t } = useTranslation();
  const [sequentialClick, setSequentialClick] = useState(true);
  const [tilesClick, setTilesClick] = useState(false);
  const [updatedImageCount, setUpdatedImageCount] = useState(0);
  const [isLocal, setIsLocal] = useState(true);
  //const defaultTabValue = window.localStorage.getItem("leftPanelTabValue") || 0;

  // useEffect(() => {
  //   if (tab1Value === 0) {
  //     let uploadImageCount = linkImages.filter(
  //       (element) => element.imageType === "Upload"
  //     );
  //     setUpdatedImageCount(uploadImageCount.length);
  //   } else if (tab1Value === 1) {
  //     let uploadImageCount2 = linkImages.filter(
  //       (element) => element.imageType === "Link"
  //     );
  //     setUpdatedImageCount(uploadImageCount2.length);
  //   } else {
  //     setUpdatedImageCount(0);
  //   }
  // });
  const handleClickSequential = () => {
    setSequentialClick(true);
    setTilesClick(false);
  };
  const handleClickTiles = () => {
    setTilesClick(true);
    setSequentialClick(false);
  };
  const uploadTabarraylength = linkImages.filter(
    (element) => element.imageType === "Upload"
  ).length;
  const linksTabarraylength = linkImages.filter(
    (element) => element.imageType === "Link"
  ).length;

  const uploadImages = useMemo(
    () =>
      sortByCreatedDateTime(
        linkImages.filter((element) => element.imageType === "Upload")
      ),
    [linkImages]
  );

  const linkTypeImages = useMemo(
    () =>
      sortByCreatedDateTime(
        linkImages.filter((element) => element.imageType === "Link")
      ),
    [linkImages]
  );

  const uploadImageListRef = useRef(null);
  const linkImageListRef = useRef(null);
  const prevUploadCountRef = useRef(null);
  const prevLinkCountRef = useRef(null);

  useEffect(() => {
    if (
      prevUploadCountRef.current !== null &&
      uploadImages.length > prevUploadCountRef.current
    ) {
      uploadImageListRef.current?.scrollTo(0, 0);
    }
    prevUploadCountRef.current = uploadImages.length;
  }, [uploadImages.length]);

  useEffect(() => {
    if (
      prevLinkCountRef.current !== null &&
      linkTypeImages.length > prevLinkCountRef.current
    ) {
      linkImageListRef.current?.scrollTo(0, 0);
    }
    prevLinkCountRef.current = linkTypeImages.length;
  }, [linkTypeImages.length]);

  return (
    <>
      <div className="imageLibrary">
        {/*   <div className="container"> */}
        {/* <div className="row">
          <div className="col-8 libraryCol">
            {t("toolbarLeftPanel.library")}
          </div>
          <img
            src={sequentialClick ? SingleBlue : Single}
            className="col-2 singleImages"
            onClick={handleClickSequential}
            alt=""
          ></img>
          <img
            src={tilesClick ? gridBlue : Grid}
            className="col-2 gridImages"
            onClick={handleClickTiles}
            alt=""
          ></img>
        </div> */}
        <AntTabs
          value={tab1Value}
          variant="fullWidth"
          onChange={handleTab1}
          className="imageTabs"
        >
          <AntTab onClick={() => setIsLocal(true)} label={`Local(${uploadTabarraylength})`} />
          <AntTab onClick={() => setIsLocal(false)} label={`Links(${linksTabarraylength})`} />
        </AntTabs>
        <div className="horizonal-line-image"></div>

        {isLocal ? (<><div className=" mt-2 mb-4">
          <div >
            <Dropzone
              ref={dropzoneRef}
              multiple={true}
              accept=".jpeg,.png,.jpg,.gif,.svg"
              onDrop={(accepted, rejected) => onDropImage(accepted, rejected)}
            >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()} style={{ display: "inline-block" }}>
                  <input {...getInputProps()} />
                  <img alt="img-upload" src={ImgSvg} />
                </div>
              )}
            </Dropzone>
          </div>
          <div className="drapDropwarning">
            <img src={warning} />
            <span className="dragdropText">{"Drag & drop or select to browse (Max 500 KB)"}</span>
          </div>
        </div>
          <div className="horizonal-line-image"></div></>)
          : (
            <>
              <div style={{ textAlign: "start", paddingLeft: "20px" }}>Image URL</div>
              <div className=" addbtn  d-flex justify-content-between">
                <DebounceInput
                  element={TextField}
                  debounceTimeout={500}
                  className="image-urlInput "
                  id="standard-basic"
                  //  placeholder="Enter URL"
                  value={URLValue}
                  placeholder={"Copy & paste or type here"}
                  onChange={(e) => handleURL(e)}
                  inputProps={{
                    style: {
                      // width: "100px",
                      height: "20px",
                      width: "186px",
                      fontSize: "10px",
                      color: "black",
                    },
                  }}
                />
                <button //className="btn btn-link  addImageBut"
                  className={
                    URLValue === ""
                      ? "btn btn-link button-disabled"
                      : "btn addImageBut"
                  }
                  style={{
                    fontWeight: "bold",
                    position: "absolute",
                    right: "30px",
                    marginTop: "-2px",
                    padding: "0px !important",
                    border: "none"
                  }}
                  disabled={URLValue === "" ? true : false}
                  onClick={URLUpdate}
                >
                  ADD
                </button>
              </div>
              <div className="horizonal-line-image mt-3"></div>
            </>
          )
        }


        {/*    <TabPanel
          value={tab1Value}
          index={0}
          className={sequentialClick || tilesClick ? "brandTab" : ""}
        ></TabPanel> */}
        <TabPanel
          value={tab1Value}
          index={0}
        //  className={sequentialClick || tilesClick ? "brandTab" : ""}
        //className="imageTabs"
        >
          <div className="imageList" ref={uploadImageListRef}>
            {uploadImages.map((linkImage) => (
              <LibraryImageItem
                key={linkImage.id || linkImage.s3Url}
                linkImage={linkImage}
                getLayerDetails={getLayerDetails}
                showDragEnd={true}
              />
            ))}

            {/* <div className="row ">
              {linkImages
                .filter((element) => element.imageType === "Upload")
                .map((linkImage, index) => {
                  return (
                    <div className="col-4 libraryCol">
                      <div className="imagePattern">
                        <img
                          src={linkImage.s3Url}
                          className="brandTabImages img-fluid "
                          alt=""
                          onDragStart={(e) => {
                            e.dataTransfer.setData("url", linkImage.s3Url);
                            getLayerDetails(
                              e.target.id,
                              IMAGE,
                              linkImage.s3Url
                            );
                            // getLayerDetails(e.target.id, IMAGE, linkImage);
                          }}
                          onDrag={(e) => {}}
                        />
                      </div>
                    </div>
                  );
                })}
            </div> */}
          </div>
        </TabPanel>
        <TabPanel
          value={tab1Value}
          index={1}
        // className={sequentialClick || tilesClick ? "brandTab" : ""}
        //  className="brandTab"
        >
          <div className="imageList mt-4" ref={linkImageListRef}>
            {linkTypeImages.map((linkImage) => (
              <LibraryImageItem
                key={linkImage.id || linkImage.s3Url}
                linkImage={linkImage}
                getLayerDetails={getLayerDetails}
              />
            ))}

            {/* <div className="row ">
              {linkImages
                .filter((element) => element.imageType === "Link")
                .map((linkImage, index) => {
                  return (
                    <div className="col-4 libraryCol">
                      <div className="imagePattern">
                        <img
                          src={linkImage.s3Url}
                          className="brandTabImages img-fluid "
                          alt=""
                          draggable={true}
                          onDragStart={(e) => {
                            e.dataTransfer.setData("url", linkImage.s3Url);
                            e.dataTransfer.setData("url", linkImage.s3Url);
                            // getLayerDetails(e.target.id, IMAGE, linkImage);
                            getLayerDetails(
                              e.target.id,
                              IMAGE,
                              linkImage.s3Url
                            );
                          }}
                          onDrag={(e) => {}}
                        />
                      </div>
                    </div>
                  );
                })}
            </div> */}
          </div>
        </TabPanel>
        {/* {showToast && showToast ? (
          <div className="showToastUpload" id="toastAppear">
            <p>{t("imageWindowTabs.linkToastMsg")}</p>
            <img
              src={ClearText}
              alt=""
              className="clearTextIcon clearText closeToast"
              onClick={handleClearLinkToast}
            />
          </div>
        ) : showErrToast && showErrToast ? (
          <div className="showerrToast" id="errToast">
            <p>{t("imageWindowTabs.linkToastErrMsg")}</p>
            <img
              src={ClearText}
              alt=""
              className="clearTexterr clearText closeToast"
              onClick={handleClearLinkErrToast}
            />
          </div>
        ) : (
          ""
        )} */}
        {/* {showToastForUplaod && showToastForUplaod ? (
          <div className="showToastUpload" id="toastAppearUpload">
            <p>{t("imageWindowTabs.uploadToastmsg")}</p>
            <img
              src={ClearText}
              alt=""
              className="clearTextIcon clearText closetoastUpload ml-4"
              onClick={handleClearToast}
            />
          </div>
        ) : showErrToastUpload && showErrToastUpload ? (
          <div className="showerrToast" id="errToast">
            <p>{t("imageWindowTabs.linkToastErrMsg")}</p>
            <img
              src={ClearText}
              alt=""
              className="clearTexterr clearText closeToast"
              onClick={handleClearLinkErrToast}
            />
          </div>
        ) : (
          ""
        )} */}
      </div>
    </>
  );
};

export default ImageLibrary;
